
export const useT = (translationKey: string, variables?: object|any) : string => {
  return (useState('i18nT') as any).value(translationKey, variables);
}

export const unlocalizeUrl = (url : string|null = null) => {

  const currentLocale = useNuxtApp().$i18n.locale.value

  if (!url) {
    url = useRouter().currentRoute.value.path
  }

  if(url.startsWith('/'+currentLocale)){
    return url.replace('/' + currentLocale, '')
  }

  if (url.startsWith(currentLocale)){
    return url.replace(currentLocale, '')
  }

  // current locale is not in the url, try all other locales defined
  const locales = useNuxtApp().$i18n.locales.value.map((l: any) => l.code)

  // foreach locales
  locales.forEach((locale: string) => {
    if (url?.startsWith(locale)) {
      url = url.replace(locale, '')
    }

    if (url?.startsWith('/' + locale)) {
      url = url.replace('/' + locale, '')
    }
  })

  return url
}
